import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { useDeleteRequisites } from "~/entity/AvtovazRequisites";
import { useGetLocationData, useSetLocationData } from "~/hooks/locationData";
import { ConfirmModal } from "~/shared/ui/ConfirmModal";

interface DeleteRequisitesIProps {
  reFetchTable?: () => void;
}

const DeleteRequisites = ({ reFetchTable }: DeleteRequisitesIProps) => {
  const { t } = useTranslation();
  const setDataReplace = useSetLocationData(true);
  const { openModal, currentId } = useGetLocationData();
  const { mutate, isSuccess, isLoading } = useDeleteRequisites();

  const handleCloseModal = () =>
    setDataReplace("openModal", "", "currentId", "");

  const deleteItem = () => {
    if (currentId) {
      mutate(Number(currentId));
    }
  };

  useEffect(() => {
    if (isSuccess) {
      handleCloseModal();
      reFetchTable?.();
    }
  }, [isSuccess]);

  return (
    <ConfirmModal
      open={openModal === "Delete"}
      title={t("avtovaz_requisite.delete_title")}
      onConfirm={deleteItem}
      onCancel={handleCloseModal}
      confirmLoading={isLoading}
      centered
      closable
      destroyOnHidden
    />
  );
};

export default DeleteRequisites;
